import BaseEntity from './base/BaseEntity.model';

export default class UserWithoutCode extends BaseEntity{
    public fullName?: string | null;
    public name?: string;
   
    constructor(){
        super();
        this.init();
    }

    init(){
        this.fullName = '';
        this.name = '';
    }
}